export const SITE_NAME = 'Juventus Club Oltre Frontiera';
export const SITE_URL = 'https://www.oltrefrontiera.ch';
export const DEFAULT_OG_IMAGE = `${SITE_URL}/android-chrome-512x512.png`;
export const DEFAULT_TITLE = SITE_NAME;
export const DEFAULT_DESCRIPTION =
  'JOFC Oltre Frontiera — club officiel de supporters de la Juventus en Suisse.';
